module.exports = __webpack_public_path__ + "5a99973d3958ae26e3118278c9a96e75.svg";